module.exports = __webpack_public_path__ + "img/pdf_icon.9405515a.svg";